import { Helmet } from "react-helmet-async";
import images from "../../images";
import {
  useGetUserInfoQuery,
  useGetUnreadInboxCountQuery,
} from "../../services/apiSlice";
import { useNavigate } from "react-router-dom";
import { cn } from "../../Utils/helper";
import { useEffect } from "react";
import { usePostHog } from "../../hooks/usePostHog";

const NewHeader = ({
  handleStarQuest,
  backgroundHeader,
  handleSignIn,
  handleSignUp,
  className = "",
}) => {
  const accessToken =
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken");
  const refreshToken =
    localStorage.getItem("refreshToken") ||
    sessionStorage.getItem("refreshToken");
  const isAuthenticated = accessToken || refreshToken;

  const { data: userInfo } = useGetUserInfoQuery(undefined, {
    skip: !isAuthenticated,
  });
  const { data: unreadData } = useGetUnreadInboxCountQuery(undefined, {
    skip: !isAuthenticated,
  });
  const unreadCount = unreadData?.total || 0;
  const { identifyUser } = usePostHog();

  const navigate = useNavigate();
  useEffect(() => {
    if (userInfo?.data?.id) {
      localStorage.setItem("customUserId", userInfo.data.id);
      localStorage.setItem("userInfo", JSON.stringify(userInfo.data));
      
      // Automatically update PostHog person profile when user data changes
      const userProfile = {
        phone_number: userInfo.data.phone || "",
        email: userInfo.data.email || "",
        name: userInfo.data.name || userInfo.data.first_name || "",
        account_status: userInfo.data.status || "",
        level: userInfo.data.level || 0,
        xp: userInfo.data.xp || 0,
        coins: userInfo.data.token || 0,
        avatar: userInfo.data.avatar_data?.file_path || "",
        last_updated: new Date().toISOString()
      };
      
      identifyUser(userInfo.data.id, userProfile);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?.data?.id, userInfo?.data?.phone, userInfo?.data?.email, userInfo?.data?.level, userInfo?.data?.xp, userInfo?.data?.token]); // ✅ Fixed: Only depend on actual data changes
  return (
    <header
      className={cn(
        `px-[30px] py-3 w-full max-w-[480px]  mx-auto rounded-none  ${
          backgroundHeader ? backgroundHeader : "bg-white"
        } `
      )}
    >
      <Helmet>
        <meta name="theme-color" content="#FFFFFF" />
      </Helmet>
      <div className={cn(`flex flex-1 justify-between  w-full ${className}`)}>
        <div
          className="flex gap-2 items-center cursor-pointer"
          onClick={() => navigate("/")}
        >
          <img
            src={images.RallyLogo2}
            alt="Rally Logo"
            className="w-[100px] h-[11px] object-contain"
          />
        </div>
        {userInfo?.data ? (
          // <div
          //   onClick={() => navigate("/profile")}
          //   className="relative bg-[#253FF6] flex gap-3 justify-center items-center rounded-md text-white px-4 h-[30px]"
          // >
          //   <div className="flex gap-1 items-center cursor-pointer">
          //     <img
          //       src={images.RallyCoinSmallWhiteIcon}
          //       alt="Logo Icon"
          //       className="w-[15px] h-[15px] object-contain"
          //     />
          //     <p className="text-lg font-bold">
          //       {userInfo?.data?.token ? parseInt(userInfo?.data?.token) : 0}
          //     </p>
          //   </div>
          //   <div className="flex gap-1 items-center cursor-pointer">
          //     <img
          //       src={images.RallyXPSmallWhiteIcon}
          //       alt="Logo Icon"
          //       className="w-[15px] h-[15px] object-contain"
          //     />
          //     <p className="text-lg font-bold">
          //       {userInfo?.data?.xp ? parseInt(userInfo?.data?.xp) : 0}
          //     </p>
          //   </div>
          //   <div className="flex gap-1 items-center cursor-pointer">
          //     <img
          //       src={images.UserSmallWhiteIcon}
          //       alt="User Icon"
          //       className="w-[24px] h-[24px] object-contain"
          //     />
          //   </div>
          //   {unreadCount > 0 && (
          //     <div className="absolute top-[-5px] right-[-5px] bg-red-500 text-white font-bold rounded-full w-[18px] h-[18px] flex items-center justify-center text-[9px] border-white border-2">
          //       {unreadCount > 99 ? "99+" : unreadCount}
          //     </div>
          //   )}
          // </div>
          <div
            onClick={() => navigate("/profile")}
            className="relative bg-[#253FF6] flex justify-between items-center rounded-md text-white px-2 h-[30px] max-w-full  gap-3"
          >
            <div className="flex gap-[5px] items-center">
              <img
                src={images.RallyCoinSmallWhiteIcon}
                alt="Coin"
                className="w-[15px] h-[15px] object-contain"
              />
              <p className="text-lg font-bold max-w-[60px] truncate">
                {userInfo?.data?.token ? parseInt(userInfo?.data?.token) : 0}
              </p>
            </div>
            <div className="flex gap-[5px] items-center">
              <img
                src={images.RallyXPSmallWhiteIcon}
                alt="XP"
                className="w-[15px] h-[15px] object-contain"
              />
              <p className="text-lg font-bold max-w-[60px] truncate">
                {userInfo?.data?.xp ? parseInt(userInfo?.data?.xp) : 0}
              </p>
            </div>

            <div className="flex items-center shrink-0">
              <img
                src={images.UserSmallWhiteIcon}
                alt="User"
                className="w-[24px] h-[24px] object-contain"
              />
            </div>
            {unreadCount > 0 && (
              <div className="absolute top-[-5px] right-[-5px] bg-red-500 text-white font-bold rounded-full w-[18px] h-[18px] flex items-center justify-center text-[9px] border-white border-2">
                {unreadCount > 99 ? "99+" : unreadCount}
              </div>
            )}
          </div>
        ) : (
          <div className="flex flex-row text-[#253FF6] text-sm font-bold gap-3">
            <span onClick={handleSignUp}>Sign Up</span>{" "}
            <span onClick={handleSignIn}>Log in</span>
          </div>
        )}
      </div>
    </header>
  );
};

export default NewHeader;
